import { displayDateWithTime } from "./displayDateWithTime";
import type { SupportedLocale } from "./displayDate";

const osloWallClock = (iso: string): string =>
  new Intl.DateTimeFormat("sv-SE", {
    timeZone: "Europe/Oslo",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hourCycle: "h23",
  })
    .format(new Date(iso))
    .replace(" ", "T");

export const displayOsloDateWithTime = (iso: string, at?: string | null, locale?: SupportedLocale | null): string =>
  displayDateWithTime(osloWallClock(iso), at, locale);
